import React,{useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const ChangePassword = () => {

    const {addData: updatePassword} = useEntityCrud('User/ChangePassword');
    const navigate = useNavigate();
    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');

    const handleBack = () => {
        navigate(-1);
    }

    const submitForm = e => {
        e.preventDefault();
        if(password != confirmPassword){
            toast.error('رمز عبور جدید و تکرار رمز عبور یکسان نمی باشند');
            return false;
        }
        const postedData = {
            username: "string",
            id: 0,
            mobile: "string",
            nationalCode: "string",
            isActive: true,
            roleId: 0,
            token: "string",
            expireDays: 0,
            firstName: "string",
            lastName: "string",
            businessId: [
                0
            ],
            password
        };
        updatePassword(postedData).then(({data}) => {
            if(data.status){
                setPassword('');
                setConfirmPassword('');
                navigate('/');
                toast.success('رمز عبور شما با موفقیت تغییر کرد');
            }
        })
    }

    return (
        <div className="row justify-content-center">
            <div className="col-md-4">
                <div className="card">
                    <div className="card-header d-flex justify-content-between">
                        <div className="card-title">تغییر رمز عبور</div>
                        <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
                    </div>
                    <div className="card-body">
                        <form onSubmit={e => submitForm(e)}>
                            <div className="form-group">
                                <label>رمز عبور جدید</label>
                                <input type="password" className="form-control ltr-input" onChange={e => setPassword(e.target.value)} value={password} />
                            </div>
                            <div className="form-group">
                                <label>تایید رمز عبور جدید</label>
                                <input type="password" className="form-control ltr-input" onChange={e => setConfirmPassword(e.target.value)} value={confirmPassword} />
                            </div>
                            <button className="btn btn-success mt-2">تغییر رمز عبور</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChangePassword;